import axios from 'axios';
import config from './ApiforContext'
const token = localStorage.getItem("token");
export default axios.create({
  baseURL: config.apiUrl,
  headers: {"Access-Control-Allow-Origin" :"*","Authorization": "Bearer " + token?.replace('"','').replace('"','').toString()}
  });
